// src/pages/churches/components/addAdminModal.js
import { useState } from "react";
import { Modal, Button, Input, message } from "antd";
import axios from "axios";
import API_ENDPOINTS from "../../../services/apiEndpoints";
import useNotification from "../../../hooks/useNotification";

export default function AddAdminModal({ church, onClose, onSuccess }) {
  const { notification, showNotification, hideNotification } = useNotification();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: ""
  });
  const [loading, setLoading] = useState(false);

  const handleAddAdmin = async () => {
    if (!form.email || !form.name) {
      message.error("Name and email are required");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`${API_ENDPOINTS.CHURCHES}/${church.churchId}/admins`, form);
      notification.success({
        message: "Admin Added",
        description: `Invitation sent to ${form.email}`
      });
      message.success(res?.data?.message || `Admin invite sent to ${form.email}`);

      onSuccess(); // close modal / refresh parent
    } catch (err) {
      console.error(err);

      const errorMessage = err?.response?.data?.message || err?.message || "Failed to add admin";

      notification.error({
        message: "Failed to Add Admin",
        description: errorMessage
      });

      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={true}
      title={`Add Admin – ${church.name} (${church.churchCode})`}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose} disabled={loading}>
          Cancel
        </Button>,
        <Button key="add" loading={loading} onClick={handleAddAdmin}>
          Add Admin
        </Button>
      ]}
    >
      <Input placeholder="Full Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={{ marginBottom: 12 }} disabled={loading} />
      <Input placeholder="Email Address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} style={{ marginBottom: 12 }} disabled={loading} />
      <Input placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} disabled={loading} />
    </Modal>
  );
}
